import { Component } from '@angular/core';

@Component({
  selector: 'cus-customers',
  imports: [],
  templateUrl: './customers.html',
  styleUrl: './customers.css',
})
export class Customers {

}
